import { inject } from '@angular/core';
import {
  setError,
  withCallState,
} from '@kinet-open-network/client/shared/data-access/state';
import { callApiMethod } from '@kinet-open-network/client/shared/util';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { ShellService } from '../services/shell.service';
import { withNotifications } from './notifications.feature';

interface IShellState {
  notSeenTicketsCount: number;
  notSeenColocationsCount: number;
  notSeenApRequestTicketsCount: number;
  autofindsCount: number;
  notApprovedReportsCount: number;
  unreadNotificationsCount: number;
  problemsCount: number;
  notApprovedOltsCount: number;
}

export const initialShellState: IShellState = {
  notSeenTicketsCount: 0,
  notSeenColocationsCount: 0,
  notSeenApRequestTicketsCount: 0,
  autofindsCount: 0,
  notApprovedReportsCount: 0,
  unreadNotificationsCount: 0,
  problemsCount: 0,
  notApprovedOltsCount: 0,
};

export const ShellStore = signalStore(
  withCallState(),
  withState(initialShellState),
  withNotifications(),
  withMethods((store, service = inject(ShellService)) => ({
    fetchNotSeenTicketsCount: () =>
      callApiMethod(() => service.getNotSeenTicketsCount(), {
        next: ({ data: notSeenTicketsCount }) =>
          patchState(store, { notSeenTicketsCount }),
        error: (err) => patchState(store, setError(err)),
      }),
    fetchNotSeenColocationsCount: () =>
      callApiMethod(() => service.getNotSeenColocationsCount(), {
        next: ({ data: notSeenColocationsCount }) =>
          patchState(store, { notSeenColocationsCount }),
        error: (err) => patchState(store, setError(err)),
      }),
    fetchAutofindsCount: () =>
      callApiMethod(() => service.getAutofindsCount(), {
        next: ({ data: autofindsCount }) =>
          patchState(store, { autofindsCount }),
        error: (err) => patchState(store, setError(err)),
      }),
    fetchNotApprovedReportsCount: () =>
      callApiMethod(() => service.getNotApprovedReportsCount(), {
        next: ({ data: notApprovedReportsCount }) =>
          patchState(store, { notApprovedReportsCount }),
        error: (err) => patchState(store, setError(err)),
      }),
    fetchProblemsCount: () =>
      callApiMethod(() => service.getProblemsCount(), {
        next: ({ data: problemsCount }) => patchState(store, { problemsCount }),
        error: (err) => patchState(store, setError(err)),
      }),
    fetchNotApprovedOltsCount: () =>
      callApiMethod(() => service.getNotApprovedOltsCount(), {
        next: ({ data: notApprovedOltsCount }) =>
          patchState(store, { notApprovedOltsCount }),
        error: (err) => patchState(store, setError(err)),
      }),
    fetchNotSeenApRequestTicketsCount: () =>
      callApiMethod(() => service.getNotSeenApRequestTicketsCount(), {
        next: ({ data: notSeenApRequestTicketsCount }) =>
          patchState(store, { notSeenApRequestTicketsCount }),
        error: (err) => patchState(store, setError(err)),
      }),
    fetchUnreadNotificationsCount: async () =>
      callApiMethod(() => service.getUnreadNotificationsCount(), {
        next: ({ data: unreadNotificationsCount }) =>
          patchState(store, { unreadNotificationsCount }),
        error: (err) => patchState(store, setError(err)),
      }),
  })),
);
